import { Component, ViewChild } from '@angular/core';
import {AlertController, NavController, NavParams, ViewController} from 'ionic-angular';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {UserData} from "../../../providers/user-data";
import * as moment from 'moment';
import * as _ from "lodash";

@Component({
    selector: 'page-timesheet',
    templateUrl: 'timesheet.html',
})
export class Timesheet {

    public mission : any;
    public alreadyRegistered: any;
    public contract : any;
    public missionData : any;
    public checkin : any;
    public checkinData: any;

    public periodKey:any;
    public period:any;
    public day:any;

    public errors:any = {};

    public formattedDate: string = '';

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public userData: UserData,
        public alertCtrl: AlertController
    ) {
        this.missionData = this.navParams.data.missionData;
        this.checkin = this.navParams.data.checkin;
        moment.locale('fr');
    }


    ionViewDidLoad() {
        var that = this;
        that.userData.userSession().subscribe(session => {
            if(session!==null)
            {
                that.userData.load().subscribe(user => {
                    var missionsCandidates = that.userData.get('missionContracts');
                    if(missionsCandidates[that.missionData.missionOffer])
                    {
                        that.mission = missionsCandidates[that.missionData.missionOffer].mission;
                    }
                    if(that.mission) {
                        that.alreadyRegistered = that.userData.get('missionCandidates/' + that.mission.id);
                    }
                    // Get period
                    // period
                    var periodKeys = this.missionData.dateString.split('-');
                    that.periodKey = periodKeys[0]+'-'+periodKeys[1];
                    that.period = that.userData.get('missionPeriods/'+that.periodKey);
                    that.day = that.period.days[this.missionData.dateString];

                    var format = moment(this.missionData.dateString);
                    that.formattedDate = format.format('dddd Do MMM ');
                });
            }
        });
    }


    dismiss(ret) {
        this.viewCtrl.dismiss(ret);
    }
    reCalculate(event)
    {
        var that = this;
        setTimeout(function(){
            var start = moment(that.day.dateString+' '+that.day.startHourString);
            var end = moment(that.day.dateString+' '+that.day.endHourString);

            // break length has hours
            var breakLength = 0;
            if(that.day.break)
            {
                var breakStart = moment(that.day.dateString+' '+that.day.breakStartHourString);
                var breakEnd = moment(that.day.dateString+' '+that.day.breakEndHourString);
                breakLength = breakEnd.diff(breakStart,"minutes");
            }
            if(end.diff(start,"minutes")<0)
                end.add(1, 'days');
            var minutes = end.diff(start,"minutes") - breakLength;


            that.day.hours = minutes/60;
        },500);
        
    }
    validateTimesheet()
    {
        var valid = true;
        if(valid)
        {
            this.day.state = 'checked-out';
            //this.userData.update('missionPeriods/'+this.periodKey,'days/'+this.day.dateString,this.day);
            this.dismiss(this.day);
        }
    }
    notWork()
    {
        var that = this;
        let alert = this.alertCtrl.create();
        alert.setTitle('Jour non travaillé');
        alert.setMessage('Pour quel motif n\'avez vous pas travaillé ce jour là ?');

        alert.addInput({
            type: 'radio',
            label: 'Demande de l\'employeur',
            value: 'demande employeur'
        });

        alert.addInput({
            type: 'radio',
            label: 'Arrêt maladie',
            value: 'maladie'
        });

        alert.addInput({
            type: 'radio',
            label: 'Autre problème personnel',
            value: 'problème personnel'
        });

        alert.addButton('Annuler');
        alert.addButton({
            text: 'Enregistrer',
            handler: (data: any) => {
                that.day.state = 'canceled';
                that.day.reason = data;
                that.dismiss(that.day);
            }
        });

        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/utils/timesheet/timesheet.ts